// extracted by css-extract-rspack-plugin
export default {"notes":"EmploymentInfomation__notes--Byd2l"};